export class PlaceClass {
    constructor (data) {
        this.address = data ? data.address : ''
        this.id = data ? data.id : ''
        this.name = data ? data.name : ''
        this.geo_lat = data ? data.address_data.geo_lat : ''
        this.geo_lon = data ? data.address_data.geo_lon : ''
        this.state = data ? data.state : 0
        this.stateHuman = this.state === 0 ? 'Активное' : 'Неактивное'
    }

    addPlace (data) {
        this.address = data ? data.address : ''
        this.id = data ? data.id : ''
        this.name = data ? data.name : ''
        this.geo_lat = data ? data.address_data.geo_lat : ''
        this.geo_lon = data ? data.address_data.geo_lon : ''
        this.state = data ? data.state : 0
        this.stateHuman = this.state === 0 ? 'Активное' : 'Неактивное'
        return this
    }

    get place () {
        return Object.assign({}, {
            address: this.address,
            id: this.id,
            name: this.name,
            geo_lat: this.geo_lat,
            geo_lon: this.geo_lon,
            state: this.state,
            stateHuman: this.stateHuman
})
    }
}
